export const fileUpload = 'file_upload';
export const removeFileUpload = 'remove_file_upload';
export const fileSubmit = 'file_submit';
export const navigateAfterSubmit = 'navigate_after_submit';
export const resumeNotProcessed = 'resume_not_processed';
export const clickEditResume = 'edit_resume';
export const clickDownloadResumeFromViewPage =
  'click_download_resume_from_view_page';
export const openFeedbackDialog = 'open_feed_back_dialog';
export const openUserJobInfoDialog = 'open_user_job_info_dialog';
export const closeUserJobInfoDialog = 'close_user_job_info_dialog';
export const closeFeedbackDialog = 'close_feed_back_dialog';
export const afterFeedbackDownloadStart = 'after_feedback_download_start';
export const shareOnWhatsapp = 'share_on_whatsapp_click';
export const shareOnLinkedin = 'share_on_linkedin_click';
export const downloadResumeFromBuilder = 'download_resume_from_builder';
export const selectStyleTab = 'select_style_tab';
export const backFromBuilder = 'back_from_builder';
export const backToEditorClick = 'back_to_editor_click';
export const closeShareDialog = 'close_share_dialog';
